module.exports = __webpack_public_path__ + "img/kruidenstempel.c3b9b68e.jpeg";